// This file is generated by pnpm icons:generate. Do not edit.

import {SquareBehindSquare_Stroke2_Corner2_Rounded as CanonicalSquareBehindSquare_Stroke2_Corner2_Rounded} from './Square'
import {SquareBehindSquare4_Stroke2_Corner0_Rounded as CanonicalSquareBehindSquare4_Stroke2_Corner0_Rounded} from './Square'

/** @deprecated Import SquareBehindSquare_Stroke2_Corner2_Rounded from `#/components/icons/Square` instead. */
export const SquareBehindSquare_Stroke2_Corner2_Rounded =
  CanonicalSquareBehindSquare_Stroke2_Corner2_Rounded

/** @deprecated Import SquareBehindSquare4_Stroke2_Corner0_Rounded from `#/components/icons/Square` instead. */
export const SquareBehindSquare4_Stroke2_Corner0_Rounded =
  CanonicalSquareBehindSquare4_Stroke2_Corner0_Rounded
